var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgOkxWallet = function SvgOkxWallet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1443_44689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 0H11C4.92487 0 0 4.92487 0 11V21C0 27.0751 4.92487 32 11 32H21C27.0751 32 32 27.0751 32 21V11C32 4.92487 27.0751 0 21 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6063 6.99255H7.39351C7.17207 6.99255 6.99255 7.17207 6.99255 7.39351V12.6063C6.99255 12.8278 7.17207 13.0073 7.39351 13.0073H12.6063C12.8278 13.0073 13.0073 12.8278 13.0073 12.6063V7.39351C13.0073 7.17207 12.8278 6.99255 12.6063 6.99255ZM18.6237 13.0073H13.4109C13.1895 13.0073 13.0099 13.1869 13.0099 13.4083V18.6211C13.0099 18.8426 13.1895 19.0221 13.4109 19.0221H18.6237C18.8452 19.0221 19.0247 18.8426 19.0247 18.6211V13.4083C19.0247 13.1869 18.8452 13.0073 18.6237 13.0073ZM19.4231 6.99255H24.6359C24.8574 6.99255 25.0369 7.17207 25.0369 7.39351V12.6063C25.0369 12.8278 24.8574 13.0073 24.6359 13.0073H19.4231C19.2016 13.0073 19.0221 12.8278 19.0221 12.6063V7.39351C19.0221 7.17207 19.2016 6.99255 19.4231 6.99255ZM12.6063 19.0221H7.39351C7.17207 19.0221 6.99255 19.2016 6.99255 19.4231V24.6359C6.99255 24.8574 7.17207 25.0369 7.39351 25.0369H12.6063C12.8278 25.0369 13.0073 24.8574 13.0073 24.6359V19.4231C13.0073 19.2016 12.8278 19.0221 12.6063 19.0221ZM19.4231 19.0221H24.6359C24.8574 19.0221 25.0369 19.2016 25.0369 19.4231V24.6359C25.0369 24.8574 24.8574 25.0369 24.6359 25.0369H19.4231C19.2016 25.0369 19.0221 24.8574 19.0221 24.6359V19.4231C19.0221 19.2016 19.2016 19.0221 19.4231 19.0221Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1443_44689"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
};

export { SvgOkxWallet as ReactComponent };
export default __webpack_public_path__ + "fe40435ad5aa89cf04f45f5611197f01.svg";